import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { G_TABLE__inputs__base } from '../_base/G_TABLE__inputs__base';
import { HOOK_TABLE_LAYOUT__inputs__model_lora } from './HOOK_TABLE_LAYOUT__inputs__model_lora';

interface PROPS {
  fields: FIELD__list_lora[];
}

export function G_TABLE__inputs__model_lora({ fields }: PROPS) {
  const columns = HOOK_TABLE_LAYOUT__inputs__model_lora({ fields });

  return <G_TABLE__inputs__base {...{ columns }} title={'MODELS LORA'} fields={fields} />;
}
